import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAddOrUpdateUrlParam } from './url-search-params.hooks';

interface TabProps {
  defaultTab: string;
}

export const useGetTab = ({ defaultTab }: TabProps) => {
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get('tab');
  const { getNewUrl } = useAddOrUpdateUrlParam();
  const navigate = useNavigate();

  useEffect(() => {
    // Only navigate if there's no tab parameter and we need to set the default
    if (!currentTab) {
      const newUrl = getNewUrl({
        key: 'tab',
        value: defaultTab,
      });
      navigate(newUrl, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    currentTab: currentTab || defaultTab,
    navigateToTab: (tab: string) => {
      const newUrl = getNewUrl({ key: 'tab', value: tab });
      navigate(`${newUrl}`);
    },
  };
};

export const useGetChildTab = ({ defaultTab }: TabProps) => {
  const [searchParams] = useSearchParams();
  const currentTab = searchParams.get('childTab');
  const { getNewUrl } = useAddOrUpdateUrlParam();
  const navigate = useNavigate();

  useEffect(() => {
    // Only navigate if there's no childTab parameter and we need to set the default
    if (!currentTab) {
      const newUrl = getNewUrl({
        key: 'childTab',
        value: defaultTab,
      });
      navigate(newUrl, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    currentTab: currentTab || defaultTab,
    navigateToTab: (tab: string) => {
      const newUrl = getNewUrl({ key: 'childTab', value: tab });
      navigate(`${newUrl}`);
    },
  };
};
